<template>
	<div class="form-container">
		<h3 class="vrnu-headline">{{ formData }}</h3>
		<b-form v-on:submit.prevent="save">
			<b-container class="no-padding">
				<b-row>
					<b-col>
						<b-form-group
							label="Titel"
							label-for="title">
							<b-form-input id="title"
								type="text"
								placeholder="Titel"
								v-model.trim="coupon.title"
								v-validate="'required'"
								data-vv-name="Titel"
								:class="{'has-error': errors.has('Titel')}">
							</b-form-input>
							<p v-if="errors.has('Titel')" class="error-message">
								{{ errors.first('Titel') }}
						    </p>
						</b-form-group>
						<b-form-group
							label="Beschreibung"
							label-for="description">
							<b-form-textarea 	id="description"
												placeholder="Beschreibung"
												v-model="coupon.description"
												v-validate="'required'"
												data-vv-name="Beschreibung"
												:class="{'has-error': errors.has('Beschreibung')}"
												:rows="3"
												:max-rows="6">
						    </b-form-textarea>
							<p v-if="errors.has('Beschreibung')" class="error-message">
								{{ errors.first('Beschreibung') }}
						    </p>
						</b-form-group>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<b-form-group	label="Gutschein gilt ab"
										label-for="validFrom">
							<vue-date-picker	v-model="coupon.validFrom"
                                v-bind:config="{
                                  format: 'DD.MM.YYYY',
                                  // minDate: moment(),
                                  locale: 'de',
                                  showTodayButton: true,
                                  showClose: true,
                                }"
                              data-vv-name="Startdatum"
                              :class="{'is-invalid': errors.has('Startdatum')}">
	     					</vue-date-picker>
	     					<p v-if="errors.has('Startdatum')" class="error-message">
								{{ errors.first('Startdatum') }}
							</p>
						</b-form-group>		     											
					</b-col>
					<b-col>
						<b-form-group	label="Gutschein gilt bis"
										label-for="validTo">
              <vue-date-picker	v-model="coupon.validTo"
                                  v-bind:config="{
                                  format: 'DD.MM.YYYY',
                                  // minDate: moment(),
                                  locale: 'de',
                                  showTodayButton: true,
                                  showClose: true,
                                 }"
                                data-vv-name="Enddatum"
                                :class="{'is-invalid': errors.has('Enddatum')}">
                  </vue-date-picker>
	     					<p v-if="errors.has('Enddatum')" class="error-message">
								{{ errors.first('Enddatum') }}
							</p>
						</b-form-group>		     											
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<b-form-group
							label="Mindestalter"
							label-for="ageFrom">
							<b-form-input id="ageFrom"
								type="text"
								placeholder="Mindestalter"
								v-model.trim="coupon.ageFrom"
								v-validate="'numeric'"
								data-vv-name="Titel"
								:class="{'has-error': errors.has('Mindestalter')}">
							</b-form-input>
							<p v-if="errors.has('Mindestalter')" class="error-message">
								{{ errors.first('Mindestalter') }}
						    </p>
						</b-form-group>
					</b-col>
					<b-col>
						<b-form-group
							label="Maximalalter"
							label-for="ageTo">
							<b-form-input id="ageTo"
								type="text"
								placeholder="Maximalalter"
								v-model.trim="coupon.ageTo"
								v-validate="'numeric'"
								data-vv-name="Maximalalter"
								:class="{'has-error': errors.has('Maximalalter')}">
							</b-form-input>
							<p v-if="errors.has('Maximalalter')" class="error-message">
								{{ errors.first('Maximalalter') }}
						    </p>
						</b-form-group>
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<b-form-group
							label="Aktiv"
							label-for="active">
							<b-form-checkbox id="active"
						                     v-model.trim="coupon.active"
						                     value="true"
						                     unchecked-value="false">
						      Der Gutschein ist aktiv und wird in der App angezeigt
						    </b-form-checkbox>			
						</b-form-group>		
					</b-col>
				</b-row>
				<b-row>
					<b-col>
						<b-form-group
							label="Anbieter"
							label-for="provider">
							<vrnu-provider-selector v-model.trim="coupon.provider"
													v-validate="'required'"
													data-vv-name="Anbieter"
													:class="{'has-error': errors.has('Anbieter')}">
							</vrnu-provider-selector>
							<p v-if="errors.has('Anbieter')" class="error-message">
								{{ errors.first('Anbieter') }}
						    </p>
						</b-form-group>
					</b-col>
				</b-row>
			</b-container>
			<b-button type="submit" class="vrnu-button" variant="primary">Speichern</b-button>
			<b-button type="reset" variant="secondary">Zurücksetzen</b-button>
		</b-form>
	</div>
</template>

<script>
// Organize imports
var moment = require('moment');
import ProviderSelector from '@/components/98_ui/ProviderSelector';
import DatePicker from 'vue-bootstrap-datetimepicker';
import 'bootstrap/dist/css/bootstrap.css';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';


export default {
	data: function() {
		return {
			isUpdate: false,
			coupon: {
				title: '',
				description: '',
				validFrom: '',
				validTo: '',
				ageFrom: '',
				ageTo: '',
				active: true,
				provider: '',
			},
		};
	},
	computed: {
	},
	methods: {
		save: function() {
			this.$validator.validate().then(result => {
				if (!result) {
					// console.log("errors", this.$validator.errors);
				} else {
					// Send provider to the server
					var data = {
						title: this.coupon.title,
						description: this.coupon.description,
						validFrom: moment(this.coupon.validFrom, "DD.MM.YYYY", 'de').toISOString(),
						validTo: moment(this.coupon.validTo, "DD.MM.YYYY", 'de').toISOString(),
						ageFrom: this.coupon.ageFrom,
						ageTo: this.coupon.ageTo,
						active: this.coupon.active,
						provider: this.coupon.provider,	
					};

					// Save coupon to the server
					if(this.isUpdate) {
						// Update the coupon
		 				this.$http.put('coupons/' + this.updateId, data).then(result => {
							this.$emit('saveSuccess', result);
							this.closeModal();
						}, response => {
							this.$emit('saveError', response);				
						});				
					} else {								
						// Save the coupon
						this.$http.post('coupons', data).then(result => {
							this.$emit('saveSuccess', result);
							this.closeModal();
						}, response => {
							this.$emit('saveError', response);				
						});
					}
				}
			});
		},
		loadCouponForUpdate: function() {
			// Get provider from server
			this.$http.get('coupons/' + this.updateId).then(coupon => {
				this.coupon = {
					title: coupon.body.title,
					description: coupon.body.description,
					validFrom: moment(coupon.body.validFrom).format("DD.MM.YYYY"),
					validTo: moment(coupon.body.validTo).format("DD.MM.YYYY"),
					ageFrom: coupon.body.ageFrom,
					ageTo: coupon.body.ageTo,
					active: coupon.body.active,
					provider: coupon.body.provider._id,
				};
			}, response => {
				// TODO: find a solution
				this.coupon = "Es ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator!";
			});
		},
		closeModal: function() {
			this.$emit('closeModal');
		},
		checkIfModeIsUpdate: function() {
			if(this.updateId !== null) {
				this.isUpdate = true;
				this.loadCouponForUpdate();
			} else {
				this.isUpdate = false;
			}
		},
		moment: function() {
			return moment();
		},
	},
	watch: {
		updateId: function() {
			this.checkIfModeIsUpdate();
		},
	},
	created: function() {
		this.checkIfModeIsUpdate();
		this.$validator.localize('de');
	},
	mounted: function() {
	},
	props: {
		formData: {
			required: true,
		},
		updateId: {
			default: null,
		}
	},
	components: {
		'vue-date-picker': DatePicker,
		'vrnu-provider-selector': ProviderSelector,
	},
}
</script>

<style>
.form-container {
	padding: 5px;
}
.mb-3 {
	margin-bottom: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/04_coupon/CouponsForm.vue